import { render, staticRenderFns } from "./MpowerImg.vue?vue&type=template&id=73ca8a6b"
import script from "./MpowerImg.vue?vue&type=script&lang=js"
export * from "./MpowerImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ca8a6b')) {
      api.createRecord('73ca8a6b', component.options)
    } else {
      api.reload('73ca8a6b', component.options)
    }
    module.hot.accept("./MpowerImg.vue?vue&type=template&id=73ca8a6b", function () {
      api.rerender('73ca8a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MpowerImg.vue"
export default component.exports